import React from 'react';
import Header from '../components/header/Header';
import userStore from '../store/userStore';
import Loader from '../components/loader';
// eslint-disable-next-line
import notificationStore from '../store/notificationStore';
import { getTreeFromDb, } from '../services/publishData';
import { setAvTables } from '../action/tableActions';
import { setUser } from '../action/userActions';
import { startUp } from '../services/startUp';
import { addNotification } from '../action/notificationAction';
import { Config } from '../config';
import { getToken, logout } from '../adal/adalConfig';

const PageHoc = (WrappedComponent) => {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                loggedIn: false,
                loading: false
            };
        }
        componentWillMount() {
            userStore.on("User-Changes", this.loggedChecker);
            if (this.props.history.location.pathname !== "/") {
                if (!this.state.loggedIn && userStore.userLoggedIn) {
                    this.setState({ loggedIn: true });
                } else if (!this.state.loggedIn && !userStore.userLoggedIn) {
                    this.setState({ loading: true });
                    getToken().then(async (token) => {
                        this.startUp(token);
                    })
                    // console.log("A user exists in memory");
                    // this.startUp(sessionStorage.getItem('auth-token'));
                }
            } else {
                console.log("here");
            }
            // if (this.state.loggedIn) {
            //     console.log("I am logged in");
            // }
            // if (!this.state.loggedIn && this.props.history.location.pathname !== "/"
            //     && !this.state.loading) {
            //     console.log("I am not logged in");
            //     this.props.history.push("/");
            // }
        }
        startUp = (authToken) => {
            this.setState({ loading: true });
            if (Config.env === "dev") {
                //im doing this to fake the user as whos off doesn't work properly when in local
                setUser({
                    authToken: "1",
                    user: {
                        company: "1a3d5b40-522f-11e9-8718-2b2d290be629",
                        // "1a3d5b40-522f-11e9-8718-2b2d290be629",
                        email: "kieran.davies@doherty.co.uk",
                        id: "1a2dbb40-f181-11e8-8caa-e9cf20d98906",
                        // 1a2dbb40-f181-11e8-8caa-e9cf20d98906",
                        principleId: "60515ca3-e2dd-4388-87e2-c071a2498b40",
                        // principleId: "a9e85f4b-400a-46a6-835f-bdf4ea7ce67f",
                        privilege: "ADMIN",
                        type: "User",
                        stage: 1
                    }
                })
                // getPublishedTrees().then((res) =>
                // setPublishTables(res))
                // .then(() => 
                getTreeFromDb()
                    .then((res) => {
                        setAvTables(res);
                        // return gatherSources();
                        // }).then((sources) => {
                        // setSource(sources);
                        this.setState({ loggedIn: true })
                        this.setState({ loading: false });
                    })
                    .catch((err) => addNotification(
                        { status: "fail", message: "Error with development startup" }));
            } else {
                if (!this.state.loggedIn) {
                    startUp().then(() => {
                        this.setState({ loggedIn: true });
                        this.setState({ loading: false });
                    }).catch((e) => {
                        this.setState({ loading: false });
                        if (Config.env !== "dev") {
                            this.props.history.push("/");
                            logout();
                        }
                    })
                }
            }

        }
        componentWillUnmount() {
            userStore.removeListener("User-Changes", this.loggedChecker);
        }
        loggedChecker = () => this.setState({ loggedIn: userStore.userLoggedIn });

        loading = (boolean) => this.setState({ loading: boolean });

        addNotification = (notifcationObject) => addNotification(notifcationObject);

        render() {
            const { loggedIn, loading } = this.state;
            if (loading) {
                return <Loader />
            }
            return (
                <div>
                    <Header history={this.props.history} />
                    <WrappedComponent{...this.props} startUp={this.startUp} loggedIn={loggedIn} loading={this.loading} 
                        addNotification={this.addNotification} />
                </div>
            )
        }
    }

}
export default PageHoc;


// WEBPACK FOOTER //
// ./src/HoC/PageHoC.js